import React from "react";

import ReactTooltip from "react-tooltip";
import Parser from "html-react-parser";

import { PriceAbs, PricePerc } from "./product-price";

import CircleInfo from "../icons/circle-info-light.svg";
import { graphql, useStaticQuery, withPrefix } from "gatsby";
import ProductNotes from "./elements/product-notes";
import { formatPrice } from "../utility/prices";
import classNames from "classnames";

const PdpProducPrice = ({ priceData, contributoRaee }) => {
  const pathPrefix = withPrefix("/");
  const {
    site: {
      siteMetadata: { priceLanguage },
    },
    config: { priceInPerc, priceWithWeee, labelDiscountYes },
    labelManagerLabels,
    productNote,
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          priceLanguage
        }
      }
      config: liferayGeneralConfiguration {
        priceInPerc
        priceWithWeee
        labelDiscountYes
      }
      labelManagerLabels {
        pricePercentageTooltip
        priceAbsoluteTooltip
        savings
        labelDiscountYes
        msrpLabel
        suggestedPriceInfo
      }
      productNote: liferayProductNotes {
        ...ProductNotesFragment
      }
    }
  `);
  const isDiscount =
    priceData?.sellingPrice?.value &&
    ((priceData?.omnibusPrice?.value &&
      priceData.sellingPrice.value < priceData.omnibusPrice.value) ||
      (!priceData?.omnibusPrice?.value &&
        priceData?.msrpPrice?.value &&
        priceData.sellingPrice.value < priceData.msrpPrice.value));
  const labelDiscount = labelDiscountYes;

  return (
    <div
      className={classNames(
        "product-detail__pricing-wrapper",
        !priceData && "product-detail__pricing-wrapper--no-price"
      )}
    >
      <div>
        <div className="product-detail__pricing d-flex flex-column flex-md-row align-items-start">
          {
            priceData && priceData?.sellingPrice?.value ? (
              <>
                <h2 className="product-detail__price">
                  {formatPrice(
                    priceData.sellingPrice?.value,
                    priceData.sellingPrice.currency,
                    priceLanguage
                  )}
                </h2>

                {isDiscount && (
                  <div className="d-flex align-items-center">
                    <span className="product-detail__original">
                      {formatPrice(
                        priceData?.omnibusPrice?.value
                          ? priceData.omnibusPrice.value
                          : priceData.msrpPrice.value,
                        priceData.sellingPrice.currency,
                        priceLanguage
                      )}
                    </span>
                    <span className="product-detail__saving d-inline-flex align-items-center">
                      {priceInPerc === "only perc" ? (
                        <>
                          <PricePerc
                            priceLanguage={priceLanguage}
                            data={priceData}
                            priceWithWeee={priceWithWeee}
                            contributoRaee={contributoRaee}
                          />
                          {labelManagerLabels?.pricePercentageTooltip && (
                            <>
                              <p
                                className="product-detail__priceInfo"
                                data-for="productPriceInfoPriceInPerc"
                                data-tip
                              >
                                <CircleInfo className="product-price__icon" />
                              </p>
                              <ReactTooltip
                                id="productPriceInfoPriceInPerc"
                                place="top"
                                effect="solid"
                                textColor="#505456"
                                type="light"
                              >
                                <CircleInfo className="product-price__icon product-price__icon--tooltip" />
                                {Parser(labelManagerLabels?.pricePercentageTooltip)}
                              </ReactTooltip>
                            </>
                          )}
                        </>
                      ) : priceInPerc === "perc and absolute" ? (
                        <>
                          <PriceAbs
                            priceLanguage={priceLanguage}
                            data={priceData}
                            priceWithWeee={priceWithWeee}
                            contributoRaee={contributoRaee}
                            save={
                              !!labelDiscount && !!labelManagerLabels.labelDiscountYes
                                ? true
                                : false
                            }
                            labelDiscount={labelManagerLabels.labelDiscountYes}
                          />{" "}
                          (
                          <PricePerc
                            priceLanguage={priceLanguage}
                            data={priceData}
                            priceWithWeee={priceWithWeee}
                            contributoRaee={contributoRaee}
                          />
                          )
                          {labelManagerLabels?.pricePercentageTooltip && (
                            <>
                              <p
                                className="product-detail__priceInfo"
                                data-for="productPriceInfo"
                                data-tip
                              >
                                <CircleInfo className="product-price__icon" />
                              </p>
                              <ReactTooltip
                                id="productPriceInfo"
                                place="top"
                                effect="solid"
                                textColor="#505456"
                                type="light"
                              >
                                <CircleInfo className="product-price__icon product-price__icon--tooltip" />
                                {Parser(labelManagerLabels?.pricePercentageTooltip)}
                              </ReactTooltip>
                            </>
                          )}
                        </>
                      ) : priceInPerc === "only abs" ? (
                        <>
                          <PriceAbs
                            priceLanguage={priceLanguage}
                            data={priceData}
                            priceWithWeee={priceWithWeee}
                            contributoRaee={contributoRaee}
                            save={
                              !!labelDiscount && !!labelManagerLabels.labelDiscountYes
                                ? true
                                : false
                            }
                            labelDiscount={labelManagerLabels.labelDiscountYes}
                          />
                          {labelManagerLabels?.priceAbsoluteTooltip && (
                            <>
                              <p
                                className="product-detail__priceInfo"
                                data-for="productPriceInfo"
                                data-tip
                              >
                                <CircleInfo className="product-price__icon" />
                              </p>
                              <ReactTooltip
                                id="productPriceInfo"
                                place="top"
                                effect="solid"
                                textColor="#505456"
                                type="light"
                              >
                                <CircleInfo className="product-price__icon product-price__icon--tooltip" />
                                {Parser(labelManagerLabels?.priceAbsoluteTooltip)}
                              </ReactTooltip>
                            </>
                          )}
                        </>
                      ) : null}
                    </span>
                  </div>
                )}
              </>
            ) : priceData === null ? null : null //TODO fallback //TODO loading
          }
        </div>
        {priceData?.msrpPrice?.value &&
          priceData?.msrpPrice?.value !== "0.0" &&
          priceData?.msrpPrice?.value > priceData?.sellingPrice?.value &&
          priceData?.omnibusPrice?.value &&
          priceData?.msrpPrice?.value > priceData?.omnibusPrice?.value &&
          pathPrefix !== "/cs_CZ/" && (
            <div className="d-flex product-detail__msrp">
              <div>
                {`${labelManagerLabels?.msrpLabel}: `}
                {formatPrice(
                  priceData.msrpPrice.value,
                  priceData.sellingPrice.currency,
                  priceLanguage
                )}
              </div>
              {labelManagerLabels?.suggestedPriceInfo && (
                <>
                  <p className="product-detail__priceInfo" data-for="productMsrpPriceInfo" data-tip>
                    <CircleInfo className="product-price__icon product-price__icon--msrp" />
                  </p>
                  <ReactTooltip
                    id="productMsrpPriceInfo"
                    place="top"
                    effect="solid"
                    textColor="#979797"
                    type="light"
                  >
                    <CircleInfo className="product-price__icon product-price__icon--msrp product-price__icon--tooltip" />
                    {Parser(labelManagerLabels?.suggestedPriceInfo)}
                  </ReactTooltip>
                </>
              )}
            </div>
          )}
      </div>
      {!!productNote && !!priceData && (
        <ProductNotes data={productNote} contributoRaee={contributoRaee} position="pdp" />
      )}
    </div>
  );
};

export default PdpProducPrice;
